import { TextField, Typography, styled } from '@mui/material';

export const StyledFieldLabel = styled(Typography)(({ theme }) => ({
  fontFamily: '"Inter", sans-serif',
  fontSize: '14px',
  fontWeight: 500,
  textAlign: 'left',
  marginBottom: theme.spacing(1),
}));

export const StyledTextField = styled(TextField)({
  width: '100%',
});
